import { Card, Flex, Select, Table, Typography } from "antd";
import React, { useState } from "react";

import arrowDown from "../../../../assets/icons/arrow-down.png";
import eye from "../../../../assets/icons/eye.png";
import "./styles.css";

export default function ActivePatients() {
  const [isDurationArrowDown, setIsDurationDown] = useState(true);

  const durationOptionProcedures = [
    { label: "1 Week", value: "1-week" },
    { label: "1 Month", value: "1-month" },
    { label: "1 Year", value: "1-year" },
  ];

  const testActivePatientsTableData = [
    { patient: { first_name: "Darya", last_name: "Rouzebahani" }, last_visited: "2025-02-02", next_appointment: "2025-03-02" },
    { patient: { first_name: "Darya", last_name: "Rouzebahani" }, last_visited: "2025-02-02", next_appointment: "2025-03-02" },
    { patient: { first_name: "Darya", last_name: "Rouzebahani" }, last_visited: "2025-02-02", next_appointment: "2025-03-02" },
    { patient: { first_name: "Darya", last_name: "Rouzebahani" }, last_visited: "2025-02-02", next_appointment: "2025-03-02" },
    { patient: { first_name: "Darya", last_name: "Rouzebahani" }, last_visited: "2025-02-02", next_appointment: "2025-03-02" },
    { patient: { first_name: "Darya", last_name: "Rouzebahani" }, last_visited: "2025-02-02", next_appointment: "2025-03-02" },
    { patient: { first_name: "Darya", last_name: "Rouzebahani" }, last_visited: "2025-02-02", next_appointment: "2025-03-02" },
    { patient: { first_name: "Darya", last_name: "Rouzebahani" }, last_visited: "2025-02-02", next_appointment: "2025-03-02" },
  ];

  const activePatientsTableColumns = [
    {
      key: "patient",
      title: "Patient",
      dataIndex: "patient",
      render: (patient) => (
        <Typography.Paragraph style={{ marginBottom: 0 }} ellipsis>{`${patient.first_name} ${patient.last_name}`}</Typography.Paragraph>
      ),
    },
    {
      key: "last-visited",
      title: "Last Visited",
      dataIndex: "last_visited",
      render: (text) => text.replace("-", "/"),
    },
    {
      key: "next-appointment",
      title: (
        <Typography.Paragraph style={{ fontWeight: 600, marginBottom: 0 }} ellipsis>
          Next Appointment
        </Typography.Paragraph>
      ),
      dataIndex: "next_appointment",
      render: (text) => text.replace("-", "/"),
    },
    {
      key: "action",
      title: "Action",
      render: () => <img src={eye} alt="eye" style={{ cursor: "pointer" }} />,
    },
  ];

  return (
    <Card style={{ width: "100%" }}>
      <Flex vertical gap={20}>
        <Flex align="center" justify="space-between">
          <Typography.Title level={4} style={{ marginBottom: 0 }}>
            Active Patients
          </Typography.Title>

          <Select
            options={durationOptionProcedures}
            defaultValue="1-month"
            style={{ width: 104, display: "flex", alignItems: "center", color: "#6b43b5" }}
            suffixIcon={<img src={arrowDown} alt="arrow-down" style={{ width: 16, transform: `rotate(${isDurationArrowDown ? "0" : "180deg"})` }} />}
            className="custom-style-selection-top-performed-procedures"
            onOpenChange={() => setIsDurationDown((down) => !down)}
          />
        </Flex>

        <Table
          columns={activePatientsTableColumns}
          dataSource={testActivePatientsTableData}
          pagination={false}
          className="fixed-body-height-scroll"
          sticky
        />
      </Flex>
    </Card>
  );
}
